import {
  acceptedClosedConfig,
  acceptedOpenConfig,
  allConfig,
  inReviewConfig,
  needsActionConfig,
  pendingConsentConfig,
} from './sentReferralsConfigs';

function getReferralColumnConfig(
  routeStatus,
  statuses = [],
  actions = [],
  isSuperNetwork,
  currentSort,
  onSortColumn,
) {
  switch (routeStatus) {
    case 'accepted/closed':
      return acceptedClosedConfig(isSuperNetwork);

    case 'accepted/open':
      return acceptedOpenConfig(isSuperNetwork);

    case 'in-review':
      return inReviewConfig(isSuperNetwork);

    case 'needs-action':
      return needsActionConfig(isSuperNetwork);

    case 'pending-consent':
      return pendingConsentConfig(actions, isSuperNetwork);

    case 'all':
    default:
      return allConfig(statuses, isSuperNetwork, currentSort, onSortColumn);
  }
}

export default getReferralColumnConfig;
